// extracted by mini-css-extract-plugin
export default {"container":"product-card_container__ds0xI","image_container":"product-card_image_container__zhnHh","fields_container":"product-card_fields_container__YTCDL"};